import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";

/**
 * @class SubscriptionEmailNotification
 *
 */
export class SubscriptionEmailNotification extends TranslatableModel {

    static get IDENT_INVOICE() {

        return 'invoice_notification';
    }

    static get IDENT_PAYMENT_RECEIVED() {

        return 'payment_received';
    }

    static get IDENT_SUBSCRIPTION_CANCELLED() {

        return 'cancel_subscription';
    }

    static get IDENT_SUBSCRIPTION_NON_RENEWING() {

        return 'cancel_on_next_renewal';
    }

    static get IDENT_SUBSCRIPTION_EXPIRED() {

        return 'subscription_expired';
    }

    static get IDENT_TRIAL_EXPIRED() {

        return 'trial_expired';
    }

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'title', 'subject', 'message' ];
    }

    static get validationModel() {

        return {
            title: {
                label: 'ENGLISH_TITLE',
            },
            title_ar: {
                label: 'ARABIC_TITLE',
            },
            send_from: {
                label: 'SENDER_EMAIL'
            },
            subject: {
                label: 'ENGLISH_SUBJECT'
            },
            subject_ar: {
                label: 'ARABIC_SUBJECT'
            },
            message: {
                label: 'MESSAGE_EN'
            },
            message_ar: {
                label: 'MESSAGE_AR'
            }
        };
    }
}

AccessorsMutatorsDecorator('id', ...SubscriptionEmailNotification.translatableAttributesWithLanguageAliases, 'status',
    'language', 'description', 'send_from', 'updated_at', 'ident')(SubscriptionEmailNotification);


// WEBPACK FOOTER //
// ./src/pms-api/models/subscription-email-notification.model.js